export enum ProductIcons {
  ArrowRight = "1",
  Bank = "2",
  Building = "3",
  BarChart = "4",
}
